//Reset data
export const RESET = "MESSAGE_REPLY_RESET"

export const SET_IS_REPLIED = "MESSAGE_REPLY_SET_IS_CREATE"
export const SET_NOT_REPLIED = "MESSAGE_REPLY_SET_NOT_CREATE"
//Loading
export const SET_TOGGLE_LOADING = "MESSAGE_REPLY_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "MESSAGE_REPLY_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "MESSAGE_REPLY_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "MESSAGE_REPLY_SET_MESSAGE"
export const SET_IS_SUCCESS = "MESSAGE_REPLY_SET_IS_SUCCESS"
export const SET_IS_ERROR = "MESSAGE_REPLY_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "MESSAGE_REPLY_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "MESSAGE_REPLY_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "MESSAGE_REPLY_SET_HIDE_MESSAGE"

//Data
export const SET_REPLY = "MESSAGE_REPLY_SET_REPLY"
export const SET_CURRENT_ITEM = "MESSAGE_REPLY_SET_CURRENT_ITEM"

//Reply
export const SET_FILE_REPLY = "MESSAGE_REFLY_SET_FILE_REPLY"
export const SET_CHUNKER_REPLY= "MESSAGE_REFLY_SET_CHUNKER_REPLY"
export const SET_PTT_REPLY = "MESSAGE_REFLY_SET_PTT_REPLY"
export const SET_MESSAGE_REPLY = "MESSAGE_REFLY_SET_MESSAGE_REPLY"
export const SET_PARENT_REPLY = "MESSAGE_REFLY_SET_PARENT_REPLY"